import { AtmosphereBackground } from '@/components/atmosphere-background';
import { LeftUnreadLogo } from '@/components/left-unread-logo';
import { home } from '@/routes';
import type { AuthLayoutProps } from '@/types';

export default function AuthSimpleLayout({
    children,
    title,
    description,
}: AuthLayoutProps) {
    return (
        <div className="dark relative flex min-h-svh flex-col items-center justify-center overflow-hidden p-6 text-foreground md:p-10">
            <AtmosphereBackground withGrain />

            <div className="relative z-10 w-full max-w-sm">
                <div className="flex flex-col gap-8 rounded-xl border border-border/60 bg-card/50 p-6 shadow-lg shadow-black/10 backdrop-blur-sm md:p-8">
                    <div className="flex flex-col items-center gap-4">
                        <LeftUnreadLogo
                            href={home()}
                            className="flex-col items-center gap-3"
                        />

                        <div className="space-y-2 text-center">
                            <h1 className="text-xl font-semibold tracking-tight">
                                {title}
                            </h1>
                            <p className="text-center text-sm text-pretty text-muted-foreground">
                                {description}
                            </p>
                        </div>
                    </div>
                    {children}
                </div>
            </div>
        </div>
    );
}
